import { render, staticRenderFns } from "./BettingResult.vue?vue&type=template&id=4cb373a4&"
import script from "./BettingResult.vue?vue&type=script&lang=js&"
export * from "./BettingResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports